import React, { useEffect, useState } from "react";
import { Box, Card, Divider, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { Tooltip } from "@material-ui/core";
import { Button, Col, Row } from "reactstrap";
import { Chip } from "@material-ui/core";
import CircularProgressWithLabel from "./CircularProgressWithLabel";
import filteringName from "../../filteringExtension/filteringName";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { useDispatch, useSelector } from "react-redux";
import {
  removeFileFromUploadList,
  selUploadList,
  changeFileUploadName,
  changeFileUploadVersion,
  setFileStatus,
  setFileRevised,
  checkCompleteUpload,
  selUploadStatus,
} from "../../slice/librarySlice";
import { makeStyles } from "@material-ui/styles";
import {
  FAILEDFILE,
  SUCCESSFILE,
  ONPROGRESSFILE,
  ONCHECK,
  DONEUPLOAD,
} from "../../slice/constants";

const useStyles = makeStyles({
  stopIcon: {
    border: "3px solid orangered",
    display: "flex",
    justifyContent: "center",
    borderRadius: 50,
    width: 30,
    height: 30,
    alignItems: "center",
    color: "orangered",
  },
  itemTable: {
    marginTop: 20,
  },
  trashIcon: {
    color: "red",
    zIndex: 1000,
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
  },
  disabledStopIcon: {
    border: "3px solid gray",
    display: "flex",
    justifyContent: "center",
    borderRadius: 50,
    width: 30,
    height: 30,
    alignItems: "center",
    color: "gray",
  },
  disabledTrashIcon: {
    color: "gray",
    zIndex: 1000,
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 8,
  },
  itemSection: {
    width: "100%",
  },
  cardSection: {
    width: "100%",
    padding: 16,
    margin: 8,
  },
  failedCardSection: {
    width: "100%",
    padding: 16,
    margin: 8,
    border: "1px solid red",
  },
  successCardSection: {
    width: "100%",
    padding: 16,
    margin: 8,
    border: "1px solid green",
  },
  onUploadCardSection: {
    width: "100%",
    padding: 16,
    margin: 8,
    border: "1px solid blue",
  },
  versionSection: {
    position: "relative",
  },
  chipSection: {
    position: "absolute",
    right: 8,
    top: 24,
  },
  finalProgress: {
    marginLeft: -3,
    color: "green",
  },
  failedProgress: {
    marginLeft: -3,
    color: "red",
  },
  successCircleBackground: {
    color: "green",
  },
  successCheck: {
    width: 46.5,
    height: 46.5,
  },
  failedCheck: {
    width: 46.5,
    height: 46.5,
  },
  cellElm: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  verInput: {
    width: 50,
  },
  error: {
    color: "red",
    fontSize: 12,
    padding: "0 26px",
  },
  marginInput: {
    marginTop: "8px !important",
  },
  btn: {
    border: "none",
    backgroundColor: "white",
    color: "black",
    padding: "0 4px",
  },
});

export default function AfterUploadModal(props) {
  const classes = useStyles();
  const uploadList = useSelector(selUploadList);
  return uploadList.length > 0 ? (
    <Card className={classes.itemSection}>
      <div className="table-responsive-material">
        <table className="table-unbordered table table-sm">
          <thead className="th-border-b">
            <tr>
              <th>Name</th>
              <th>Previose Version</th>
              <th>New Version</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {uploadList.map((item, idx) => {
              // const isUpdate = updateFiles[idx];
              return (
                <MultiListRow item={item} idx={idx} key={`item_upload${idx}`} />
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  ) : (
    false
  );
}

const MultiListRow = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { item, idx } = props;
  const {
    fileStatus,
    name,
    version,
    isRevised,
    revisedFile,
    progress,
    cancelToken,
    titleValidation,
    checkVersion,
  } = item;

  const uploadStutus = useSelector(selUploadStatus);
  async function handleRemove() {
    await cancelToken.cancel();
    // dispatch(checkCompleteUpload());
    return dispatch(removeFileFromUploadList(idx));
  }
  async function handleRemoveWithCheck() {
    await cancelToken.cancel();
    dispatch(checkCompleteUpload());
    return dispatch(removeFileFromUploadList(idx));
  }
  // function handleNameChange(e) {
  //   const { value } = e.target;
  //   dispatch(changeFileUploadName({ idx, value }));
  // }
  function handleVersionChange(e) {
    const { value } = e.target;
    dispatch(changeFileUploadVersion({ value, idx }));
  }

  const errorText = () => {
    if (version === "") return "version is required";
    if (!checkVersion) return "this version is assigned before";
  };

  return (
    <tr>
      <td>
        <div className={`${classes.itemTable} user-detail`}>
          <h5 className="user-name">
            <Tooltip arrow title={item.name !== undefined ? item.name : "N/A"}>
              <Button className={classes.btn}>
                {filteringName(item.name, 15)}
              </Button>
            </Tooltip>
          </h5>
        </div>
      </td>
      <td>
        <div className={`${classes.itemTable} user-detail`}>
          <h5 className="user-name">
            {isRevised ? revisedFile.version : "N/A"}
          </h5>
        </div>
      </td>
      <td>
        <div className={`user-detail`}>
          <h5 className="user-name">
            <TextField
              disabled={progress > 0}
              type="text"
              value={version}
              onChange={handleVersionChange}
              margin="normal"
              placeholder={
                isRevised && `Current version: ${revisedFile.version}`
              }
              error={!checkVersion}
              helperText={!checkVersion && errorText()}
              className={classes.marginInput}
            />
          </h5>
        </div>
      </td>
      <td>
        {fileStatus === SUCCESSFILE ? (
          <div className={classes.finalProgress}>
            <CheckCircleOutlineIcon className={classes.successCheck} />
          </div>
        ) : (
          false
        )}
        {fileStatus === ONPROGRESSFILE ? (
          <CircularProgressWithLabel value={progress} />
        ) : (
          false
        )}
        {fileStatus === FAILEDFILE ? (
          <div className={classes.failedProgress}>
            <ErrorOutlineIcon className={classes.failedCheck} />
          </div>
        ) : (
          false
        )}
      </td>

      <td>
        <div className={`user-detail`}>
          <h5 className="user-name">
            {uploadStutus !== DONEUPLOAD ? (
              <IconButton
                className={classes.trashIcon}
                onClick={
                  uploadStutus === ONCHECK
                    ? handleRemove
                    : handleRemoveWithCheck
                }
              >
                <i className={`${classes.trashIconRemove} zmdi zmdi-close`}></i>
              </IconButton>
            ) : (
              <IconButton className={classes.disabledTrashIcon}>
                <i className="zmdi zmdi-close"></i>
              </IconButton>
            )}
          </h5>
        </div>
      </td>
    </tr>
  );
};
